import AgentMessage from './AgentMessage';
import DestinationInfo from './DestinationInfo';
import HowToProceed from './HowToProceed';
import Itinerary from './Itinerary';
import Passenger from './Passenger';
import PricingSummary from './PricingSummary';
import QuotePdfHeader from './QuotePdfHeader';
import TermsAndConditions from './TermsAndConditions';
import { fontSemiBold, text3xl, secondaryColor, gap2 } from './styleConstants';

export default function QuotePdfTemplate() {
  const xMargins = { marginRight: '3rem', marginLeft: '3rem' };
  const marginBottom = { marginBottom: '2rem' };
  const marginTop = { marginTop: '2rem' };

  const contentSpacerStyle = {
    ...marginBottom,
    ...marginTop,
    ...xMargins,
  };

  return (
    <>
      <QuotePdfHeader xMargins={xMargins} />
      <div style={contentSpacerStyle}>
        <h1
          style={{
            marginBottom: '1rem',
            fontSize: text3xl,
            lineHeight: '2.25rem',
            fontWeight: fontSemiBold,
            color: secondaryColor,
          }}
        >
          Quotation Details
        </h1>
        <div style={{ display: 'flex', flexWrap: 'wrap' }}>
          <div style={{ display: 'flex', gap: gap2, width: '50%' }}>
            <p>Quote reference:</p>
            <p>32154</p>
          </div>
          <div style={{ display: 'flex', gap: gap2, width: '50%' }}>
            <p>Quoted by:</p>
            <p>Jordan Lamber</p>
          </div>
          <div style={{ display: 'flex', gap: gap2, width: '50%' }}>
            <p>Quotation Date:</p>
            <p>28 April 2022</p>
          </div>
          <div style={{ display: 'flex', gap: gap2, width: '50%' }}>
            <p>Email address:</p>
            <p>Jordan.Lamber@suntravel.co.uk</p>
          </div>
        </div>
      </div>
      <AgentMessage xMargins={xMargins} />
      <Passenger
        xMargins={xMargins}
        marginTop={marginTop}
        marginBottom={marginBottom}
      />
      <DestinationInfo xMargins={xMargins} marginTop={marginTop} />
      <Itinerary xMargins={xMargins} marginTop={marginTop} />
      <PricingSummary xMargins={xMargins} marginTop={marginTop} />
      <HowToProceed xMargins={xMargins} marginTop={marginTop} />
      <TermsAndConditions xMargins={xMargins} marginTop={marginTop} />
    </>
  );
}
